/* Faithful visual port of the approved NuMuti homepage; no commerce bindings. */
(() => {

/* Allow marked draft-page links; keep signup, cart and checkout inactive. */
document.addEventListener('click', event => {
  const target = event.target instanceof Element ? event.target : event.target.parentElement;
  if (!target) return;
  if (target.closest('[data-nu-commerce], .nu-cart-open, [data-nu-add-to-cart], [data-nu-connected-form], [data-nu-connected-link]')) return;
  const link = target.closest('a[href]');
  const href = link && link.getAttribute('href');
  const outboundLink = link && !link.hasAttribute('data-nu-preview-link') && !(href && href.startsWith('#'));
  const control = target.closest('[data-foundation-disabled], [name=add], [data-add-to-cart], .shopify-payment-button, [name=checkout], [data-cart-checkout]');
  if (!control && !outboundLink) return;
  event.preventDefault();
  event.stopImmediatePropagation();
}, true);
document.addEventListener('submit', event => {
  if (event.target.matches('form[data-nu-connected-form]')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
}, true);

/* Source: inline-script-1 */
(() => {

  (function(){
    var sec = document.getElementById('shop');
    var btns = sec.querySelectorAll('.fbtn');
    var panes = sec.querySelectorAll('.flavpane');
    btns.forEach(function(b){
      b.addEventListener('click', function(){
        var f = b.getAttribute('data-flav');
        btns.forEach(function(x){
          var on = (x === b);
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panes.forEach(function(p){
          p.classList.toggle('is-hidden', p.getAttribute('data-pane') !== f);
        });
        var zone = document.getElementById('flavzone');
        if (zone) zone.classList.toggle('is-baobab', f === 'baobab');
      });
    });
  })();
  
})();

/* Source: inline-script-2 */
(() => {

const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), {threshold: 0.12});
document.querySelectorAll('.reveal:not(.timeline)').forEach(el => io.observe(el));
// the anatomy timeline resets off-screen and draws fresh each time you reach it
const iot = new IntersectionObserver(es => es.forEach(e => {
  const el = e.target;
  el.classList.add('anim-reset'); el.classList.remove('in'); void el.offsetWidth; el.classList.remove('anim-reset');
  if (e.isIntersecting) el.classList.add('in');
}), {threshold: 0.5});
document.querySelectorAll('.timeline').forEach(el => iot.observe(el));

})();

/* Source: inline-script-3 */
(() => {

/* Fit the hero beneath the actual announcement and navigation heights. */
(()=>{const bars=[document.querySelector(".announce"),document.querySelector("header")].filter(Boolean);const fit=()=>document.documentElement.style.setProperty("--hero-top-height",bars.reduce((sum,bar)=>sum+bar.getBoundingClientRect().height,0)+"px");fit();const observer=new ResizeObserver(fit);bars.forEach(bar=>observer.observe(bar));})();

})();

/* Source: build_assets/home-page-version-1/timeline.js */
(() => {
(() => {
 const section=document.querySelector('.nvt');
 if(!section)return;
 let visible=false;
 const replay=()=>{
  section.classList.remove('nvt-active');
  void section.offsetWidth;
  section.classList.add('nvt-active');
 };
 window.replayAnatomy=replay;
 new IntersectionObserver(entries=>entries.forEach(entry=>{
  if(entry.intersectionRatio>=.4&&!visible){visible=true;replay()}
  else if(!entry.isIntersecting){visible=false;section.classList.remove('nvt-active')}
 }),{threshold:[0,.4]}).observe(section);
 window.addEventListener('load',()=>document.fonts.ready.then(()=>{
  if(location.hash==='#anatomy-timeline')window.scrollTo({top:section.offsetTop-94,behavior:'instant'});
 }));
})();

})();

/* Source: build_assets/home-page-version-1/flavor-tabs.js */
(() => {
(() => {
  const tabs=[...document.querySelectorAll('#shop .fbtn')];
  tabs.forEach((tab,index)=>{
    tab.addEventListener('click',()=>tabs.forEach(other=>other.tabIndex=other===tab?0:-1));
    tab.addEventListener('keydown',event=>{
      let next;
      if(event.key==='ArrowRight') next=(index+1)%tabs.length;
      else if(event.key==='ArrowLeft') next=(index+tabs.length-1)%tabs.length;
      else if(event.key==='Home') next=0;
      else if(event.key==='End') next=tabs.length-1;
      else return;
      event.preventDefault();tabs[next].focus();tabs[next].click();
    });
  });
})();

})();

/* Source: build_assets/ugc/ugc.js */
(() => {
(() => {
  const cards = document.querySelectorAll('[data-ugc-src]');
  if (!cards.length) return;

  const dialog = document.createElement('dialog');
  dialog.className = 'ugc-viewer';
  dialog.setAttribute('aria-labelledby', 'ugc-viewer-title');
  dialog.innerHTML = '<div class="ugc-viewer-top"><p class="ugc-viewer-title" id="ugc-viewer-title"></p><button class="ugc-viewer-close" type="button" aria-label="Close video">Close</button></div><video controls playsinline preload="none"></video><p class="ugc-viewer-status" role="status" hidden></p>';
  document.body.append(dialog);
  const player = dialog.querySelector('video');
  const title = dialog.querySelector('.ugc-viewer-title');
  const status = dialog.querySelector('.ugc-viewer-status');
  let opener = null;
  let dialogRequest = 0;

  // Load only previews actually visible in the page or horizontal rail.
  const previews = Array.from(cards, card => {
    const video = card.querySelector('.ugc-preview');
    if (!video) return null;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = false;
    video.setAttribute('muted', '');
    return { card, video, visible: false, pending: false, failed: false, request: 0 };
  }).filter(Boolean);
  const shouldPlayPreview = state => state.visible && !document.hidden && !dialog.open;
  function syncPreview(state) {
    const { video } = state;
    if (!shouldPlayPreview(state)) {
      state.request += 1;
      state.pending = false;
      video.pause();
      return;
    }
    if (state.failed || state.pending || !video.paused) return;
    video.muted = true;
    if (!video.hasAttribute('src')) video.src = state.card.dataset.ugcSrc;
    const request = ++state.request;
    state.pending = true;
    const failed = error => {
      if (request !== state.request) return;
      state.pending = false;
      if (error && error.name === 'AbortError') return;
      // Restore the poster if autoplay is refused or the clip cannot load.
      state.failed = true;
      video.pause();
      video.removeAttribute('src');
      video.load();
    };
    try {
      Promise.resolve(video.play()).then(() => {
        if (request === state.request) state.pending = false;
        // A stale play promise must not pause a newer, wanted playback request.
        if (!shouldPlayPreview(state)) video.pause();
      }, failed);
    } catch (error) {
      failed(error);
    }
  }
  const syncPreviews = () => previews.forEach(syncPreview);
  if (previews.length) {
    const states = new Map(previews.map(state => [state.video, state]));
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const state = states.get(entry.target);
        state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.12;
        syncPreview(state);
      });
    }, { threshold: [0, 0.12] });
    previews.forEach(state => observer.observe(state.video));
  }

  cards.forEach(card => card.addEventListener('click', () => {
    const request = ++dialogRequest;
    opener = card;
    title.textContent = card.dataset.ugcTitle;
    player.setAttribute('aria-label', card.dataset.ugcTitle);
    status.hidden = true;
    status.textContent = '';
    player.src = card.dataset.ugcSrc;
    dialog.showModal();
    document.documentElement.classList.add('ugc-player-open');
    syncPreviews();
    player.play().catch(() => {
      if (!dialog.open || request !== dialogRequest) return;
      status.textContent = 'Press play to start the video.';
      status.hidden = false;
    });
  }));

  dialog.querySelector('.ugc-viewer-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    dialogRequest += 1;
    player.pause();
    player.removeAttribute('src');
    player.load();
    document.documentElement.classList.remove('ugc-player-open');
    opener?.focus({preventScroll: true});
    syncPreviews();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) player.pause();
    syncPreviews();
  });
  player.addEventListener('error', () => {
    if (!player.hasAttribute('src')) return;
    status.textContent = 'The video could not load. Please close it and try again.';
    status.hidden = false;
  });
})();

})();


/* Source: build_assets/home-page-version-1/mobile-social-rails.js */
(() => {
(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('.mobile-social-rail').forEach(rail => {
    let gesture = null;
    let ignoreClickUntil = 0;

    // Touch and trackpad use the browser's native horizontal scrolling.
    // This also lets the desktop phone preview be dragged with a mouse.
    rail.addEventListener('pointerdown', event => {
      if (!mobile.matches || event.pointerType !== 'mouse' || event.button !== 0) return;
      ignoreClickUntil = 0;
      gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, left: rail.scrollLeft, dragging: false };
    });

    window.addEventListener('pointermove', event => {
      if (!gesture || gesture.id !== event.pointerId) return;
      if (event.buttons === 0) { finish(event); return; }
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (!gesture.dragging) {
        if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { gesture = null; return; }
        if (Math.abs(dx) < 8) return;
        gesture.dragging = true;
        rail.classList.add('is-dragging');
        rail.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      rail.scrollLeft = gesture.left - dx;
    });

    const finish = event => {
      if (!gesture || gesture.id !== event.pointerId) return;
      const wasDragging = gesture.dragging;
      gesture = null;
      rail.classList.remove('is-dragging');
      if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
      if (!wasDragging) return;
      ignoreClickUntil = Date.now() + 500;
      const first = rail.firstElementChild;
      const max = rail.scrollWidth - rail.clientWidth;
      const stops = [...rail.children].map(card => Math.min(max, card.offsetLeft - first.offsetLeft));
      const nearest = stops.reduce((best, stop) => Math.abs(stop - rail.scrollLeft) < Math.abs(best - rail.scrollLeft) ? stop : best);
      rail.scrollTo({ left: nearest, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    };
    window.addEventListener('pointerup', finish);
    window.addEventListener('pointercancel', finish);
    window.addEventListener('blur', () => {
      if (gesture) finish({ pointerId: gesture.id });
    });
    rail.addEventListener('lostpointercapture', finish);
    rail.addEventListener('dragstart', event => { if (mobile.matches) event.preventDefault(); });
    rail.addEventListener('click', event => {
      if (event.detail > 0 && Date.now() < ignoreClickUntil) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
  });
})();

})();

/* Source: build_assets/home-page-version-1/mobile-timeline.js */
(() => {
(() => {
  const section = document.querySelector('#anatomy-timeline');
  if (!section) return;
  const source = [...section.querySelectorAll('.nvt-moment')];
  const desktopGraph = section.querySelector('.nvt-curve svg');
  if (source.length !== 4 || !desktopGraph) return;
  const mobile = window.matchMedia('(max-width: 767px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const colors = ['#F0BD55', '#F0BD55', '#D84596', '#B66990'];
  // Reuse the desktop geometry and aspect ratio without reshaping or stretching it.
  const viewBox = desktopGraph.getAttribute('viewBox');
  const graphWidth = Number(viewBox.split(/[ ,]+/)[2]);
  const points = [...desktopGraph.querySelectorAll('circle[r="5"]')].map(point => [Number(point.getAttribute('cx')), Number(point.getAttribute('cy'))]);
  const curve = desktopGraph.querySelector('.nvt-curve-base').getAttribute('d');
  const labels = ['0 min', '15 min', '30 min', '2 hrs+'];
  const root = document.createElement('div');
  root.className = 'nmt';
  root.innerHTML = `
    <svg class="nmt-graph" viewBox="${viewBox}" fill="none" aria-hidden="true">
      <defs><linearGradient id="nmt-ink" x1="120" y1="0" x2="1080" y2="0" gradientUnits="userSpaceOnUse"><stop stop-color="#F0BD55"/><stop offset=".28" stop-color="#F0BD55"/><stop offset=".59" stop-color="#D84596"/><stop offset="1" stop-color="#B66990"/></linearGradient></defs>
      <path class="nmt-base" d="${curve}"/>
      <path class="nmt-progress" d="${curve}" pathLength="1" stroke="url(#nmt-ink)"/>
      ${points.map(([x, y], i) => `<circle class="nmt-halo" cx="${x}" cy="${y}" r="32" style="--point-color:${colors[i]}"/><circle class="nmt-point" cx="${x}" cy="${y}" r="14" style="--point-color:${colors[i]}"/>`).join('')}
    </svg>
    <div class="nmt-times" role="tablist" aria-label="Explore the NuMuti experience"></div>
    <div class="nmt-stories" aria-label="Experience stages"></div>
`;
  const times = root.querySelector('.nmt-times');
  const scroller = root.querySelector('.nmt-stories');
  source.forEach((moment, index) => {
    const button = document.createElement('button');
    button.className = 'nmt-time';
    button.type = 'button';
    button.id = `nmt-time-${index}`;
    button.setAttribute('role', 'tab');
    button.setAttribute('aria-label', labels[index]);
    button.setAttribute('aria-controls', `nmt-story-${index}`);
    button.style.setProperty('--time-color', colors[index]);
    button.style.setProperty('--time-x', `${points[index][0] / graphWidth * 100}%`);
    button.append(document.createTextNode(labels[index].split(' ')[0]));
    const unit = document.createElement('span');
    unit.textContent = labels[index].split(' ')[1];
    button.append(unit);
    times.append(button);
    const panel = document.createElement('article');
    panel.className = 'nmt-panel';
    panel.id = `nmt-story-${index}`;
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', button.id);
    for (const [selector, tag, className] of [['.nvt-stage', 'p', 'nmt-stage'], ['h3', 'h3', ''], ['.nvt-copy', 'p', 'nmt-copy']]) {
      const element = document.createElement(tag);
      element.className = className;
      element.textContent = moment.querySelector(selector).textContent;
      panel.append(element);
    }
    scroller.append(panel);
  });
  section.querySelector('.nvt-wrap').append(root);
  const buttons = [...times.children];
  const panels = [...scroller.children];
  const path = root.querySelector('.nmt-progress');
  // Keep the graph usable if SVG geometry is unavailable during initial layout.
  const firstX = points[0][0];
  const spanX = points[points.length - 1][0] - firstX;
  let progress = points.map(([x]) => (x - firstX) / spanX);
  try {
    const total = path.getTotalLength();
    if (Number.isFinite(total) && total > 0) {
      progress = points.map(([x], index) => {
        if (index === 0) return 0;
        if (index === points.length - 1) return 1;
        let low = 0, high = total;
        for (let n = 0; n < 22; n++) {
          const middle = (low + high) / 2;
          if (path.getPointAtLength(middle).x < x) low = middle;
          else high = middle;
        }
        return (low + high) / (2 * total);
      });
    }
  } catch (_) { /* Retain the positions derived from the source graph. */ }
  const dots = [...root.querySelectorAll('.nmt-point')];
  const halos = [...root.querySelectorAll('.nmt-halo')];
  const storyWidth = () => scroller.getBoundingClientRect().width;
  let active = 0;
  let inView = false;
  let pointerHeld = false;
  let timer = null;
  let programmaticTarget = null;
  let scrollSettleTimer = null;
  // Each stage stays readable for four seconds after it settles into view.
  const readingTime = 4000;
  function canAdvance() {
    let keyboardFocused = false;
    try { keyboardFocused = root.contains(document.activeElement) && document.activeElement.matches(':focus-visible'); }
    catch (_) { /* Older browsers can still use the touch controls. */ }
    return mobile.matches && inView && !document.hidden && !keyboardFocused && !pointerHeld && programmaticTarget === null && active < 3;
  }
  function restartAuto() {
    clearTimeout(timer);
    timer = null;
    const complete = active === 3;
    root.dataset.playback = complete ? 'complete' : canAdvance() ? 'playing' : 'waiting';
    if (canAdvance()) timer = setTimeout(() => {
      timer = null;
      if (canAdvance()) goTo(active + 1);
    }, readingTime);
  }
  function select(index) {
    const focusedPanel = panels.find(panel => panel.contains(document.activeElement));
    active = Math.max(0, Math.min(3, index));
    root.dataset.stage = String(active);
    root.style.setProperty('--nmt-offset', String(1 - progress[active]));
    buttons.forEach((button, i) => {
      button.setAttribute('aria-selected', String(i === active));
      button.tabIndex = i === active ? 0 : -1;
      panels[i].setAttribute('aria-hidden', String(i !== active));
      panels[i].tabIndex = i === active ? 0 : -1;
      dots[i].classList.toggle('is-reached', i <= active);
      halos[i].classList.toggle('is-current', i === active);
    });
    if (focusedPanel && focusedPanel !== panels[active]) panels[active].focus({ preventScroll: true });
    restartAuto();
  }
  function cancelScrollTarget() {
    clearTimeout(scrollSettleTimer);
    scrollSettleTimer = null;
    programmaticTarget = null;
  }
  function queueScrollSettle() {
    clearTimeout(scrollSettleTimer);
    // Native scrolling must settle before another four-second reading interval.
    scrollSettleTimer = setTimeout(() => {
      scrollSettleTimer = null;
      programmaticTarget = null;
      const width = storyWidth();
      const index = width ? Math.round(scroller.scrollLeft / width) : active;
      if (index !== active) select(index);
      else restartAuto();
    }, 160);
  }
  function goTo(index, focus = false) {
    index = Math.max(0, Math.min(3, index));
    if (focus) buttons[index].focus({ preventScroll: true });
    // Keep the chosen graph stage while its story slides into position.
    programmaticTarget = index;
    select(index);
    const left = storyWidth() * index;
    try { scroller.scrollTo({ left, behavior: reducedMotion.matches ? 'auto' : 'smooth' }); }
    catch (_) { scroller.scrollLeft = left; }
    // Also settle same-stage or instant scrolls that emit no scroll event.
    queueScrollSettle();
  }
  buttons.forEach((button, index) => {
    button.addEventListener('click', () => {
      goTo(index);
      // Tapping the current stage also gives it a fresh reading interval.
      restartAuto();
    });
    button.addEventListener('keydown', event => {
      const next = { ArrowRight: Math.min(index + 1, 3), ArrowLeft: Math.max(index - 1, 0), Home: 0, End: 3 }[event.key];
      if (next === undefined) return;
      event.preventDefault();
      restartAuto();
      goTo(next, true);
    });
  });
  let scheduled = false;
  scroller.addEventListener('scroll', () => {
    if (!mobile.matches) return;
    queueScrollSettle();
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      const width = storyWidth();
      if (!width || programmaticTarget !== null) return;
      const index = Math.round(scroller.scrollLeft / width);
      if (index !== active) select(index);
    });
  }, { passive: true });
  // Touch and trackpad use native scrolling; mouse dragging supports the phone preview too.
  let drag = null;
  scroller.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    event.preventDefault();
    drag = { id: event.pointerId, x: event.clientX, left: scroller.scrollLeft, moved: false };
    scroller.setPointerCapture(event.pointerId);
  });
  scroller.addEventListener('pointermove', event => {
    if (!drag || event.pointerId !== drag.id) return;
    const delta = event.clientX - drag.x;
    if (!drag.moved && Math.abs(delta) < 5) return;
    if (!drag.moved) {
      drag.moved = true;
      scroller.classList.add('is-dragging');
    }
    event.preventDefault();
    scroller.scrollLeft = drag.left - delta;
  });
  function endDrag(event) {
    if (!drag || event.pointerId !== drag.id) return;
    const moved = drag.moved;
    drag = null;
    if (scroller.hasPointerCapture(event.pointerId)) scroller.releasePointerCapture(event.pointerId);
    scroller.classList.remove('is-dragging');
    if (moved && storyWidth()) goTo(Math.round(scroller.scrollLeft / storyWidth()));
  }
  scroller.addEventListener('pointerup', endDrag);
  scroller.addEventListener('pointercancel', endDrag);
  scroller.addEventListener('lostpointercapture', endDrag);
  let previousWidth = 0;
  new ResizeObserver(() => {
    const width = storyWidth();
    if (!mobile.matches || !width) { previousWidth = 0; return; }
    if (width === previousWidth) return;
    previousWidth = width;
    // Keep a 2px visible line without non-scaling-stroke distorting the normalized dashes.
    path.style.strokeWidth = String(2 * graphWidth / width);
    scroller.scrollTo({ left: width * active, behavior: 'auto' });
  }).observe(scroller);
  root.addEventListener('pointerdown', () => { cancelScrollTarget(); pointerHeld = true; restartAuto(); }, { passive: true });
  const release = () => {
    if (!pointerHeld) return;
    pointerHeld = false;
    restartAuto();
  };
  window.addEventListener('pointerup', release, { passive: true });
  window.addEventListener('pointercancel', release, { passive: true });
  scroller.addEventListener('lostpointercapture', release);
  window.addEventListener('blur', () => {
    if (drag) endDrag({ pointerId: drag.id });
    release();
  });
  root.addEventListener('wheel', () => { cancelScrollTarget(); restartAuto(); }, { passive: true });
  root.addEventListener('focusin', restartAuto);
  root.addEventListener('focusout', () => queueMicrotask(restartAuto));
  new IntersectionObserver(entries => {
    // Begin as the graph enters view; do not require nearly all of the text panel.
    const wasInView = inView;
    inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
    if (inView && !wasInView && active === 3) goTo(0);
    else restartAuto();
  }, { threshold: [0, .25] }).observe(root.querySelector('.nmt-graph'));
  document.addEventListener('visibilitychange', restartAuto);
  mobile.addEventListener('change', restartAuto);
  reducedMotion.addEventListener('change', restartAuto);
  section.classList.add('nmt-ready');
  select(0);
})();

})();

/* Source: build_assets/shared-site-chrome/mobile-navigation.js */
(() => {
/* Shared dropdown navigation for desktop and mobile. */
(() => {
  const header = document.querySelector('header.numuti-header');
  if (!header) return;
  const toggle = header.querySelector('.mobile-menu-toggle');
  const navigation = header.querySelector('#numuti-mobile-menu');
  if (!toggle || !navigation) return;
  const mobile = window.matchMedia('(max-width: 767px)');
  let open = false;

  function render() {
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    navigation.hidden = !open;
  }
  function close(returnFocus = false) {
    open = false;
    render();
    if (returnFocus) toggle.focus();
  }

  toggle.hidden = false;
  header.classList.add('mobile-nav-ready');
  render();
  toggle.addEventListener('click', () => {
    open = !open;
    render();
  });
  toggle.addEventListener('keydown', event => {
    if (event.key !== 'ArrowDown') return;
    event.preventDefault();
    open = true;
    render();
    navigation.querySelector('a[href]')?.focus();
  });
  navigation.addEventListener('click', event => {
    if (event.target.closest('a[href]')) close();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && open) {
      event.preventDefault();
      close(true);
    }
  });
  document.addEventListener('click', event => {
    if (open && !header.contains(event.target)) close();
  });
  header.addEventListener('focusout', () => {
    requestAnimationFrame(() => {
      if (open && !header.contains(document.activeElement)) close();
    });
  });
  mobile.addEventListener('change', () => {
    const focusWasInNavigation = navigation.contains(document.activeElement);
    close(focusWasInNavigation);
  });
})();

})();

/* Source: build_assets/home-page-version-1/mobile-intro-options.js */
(() => {
/* Accepted responsive image/copy order; no review-variant URL controls. */
(() => {
  const section = document.getElementById('mobile-intro');
  if (!section) return;
  const wrap = section.querySelector('.feelwrap');
  const copy = wrap.querySelector('.feel-copy');
  const icons = wrap.querySelector('.feel-benefits');
  const image = wrap.querySelector('.render-scene');
  if (!copy || !icons || !image) return;
  const option = '2';
  const mobile = window.matchMedia('(max-width: 767px)');
  const orders = { '1': [copy, icons, image], '2': [image, copy, icons] };
  function arrange() {
    section.dataset.mobileIntro = option;
    const order = mobile.matches ? orders[option] : orders['1'];
    order.forEach(node => wrap.appendChild(node));
  }
  arrange();
  mobile.addEventListener('change', arrange);
})();

})();
})();
